module.exports = __webpack_public_path__ + "assets/9ada6dd02e5de2855d9130a31b68db8d.png";